import { ICuttingBaseMaterial, TextureSettings } from './cutting-base-material.model';
import { CuttingOffcut } from './cutting-offcut.model';
import { CuttingPanel } from './cutting-panel.model';

export enum MaterialType {
  Plate,
  Linear,
  Butt,
}

export class CuttingMaterial implements ICuttingBaseMaterial {
  id = 0;
  name = '';
  thickness = 0;
  article = '';
  type: MaterialType = MaterialType.Plate;
  panels: CuttingPanel[];
  textureName = '';
  textureRotationDegree: number;
  color = '';
  inMaterialBaseId = 0;
  inMaterialBaseGroupId = 0;
  height = 0;
  width = 0;
  offcuts: CuttingOffcut[];
  usedOffcuts: CuttingOffcut[];
  price = 0;
  measureName: string;
  groupId: number;
  weightPerItem: number;
  textureLink = '';
  cropTextureLink = '';
  quantityInStock: number;
  textureSettings?: TextureSettings;

  constructor(mat?: CuttingMaterial | any) {
    mat = mat || {};
    this.id = mat.id || 0;
    this.height = mat.height || 0;
    this.width = mat.wWidth || 0;
    this.inMaterialBaseId = mat.inMaterialBaseId || 0;
    this.price = mat.price || 0;
    this.inMaterialBaseGroupId = mat.inMaterialBaseGroupId || 0;
    this.thickness = mat.thickness || 0;
    this.article = mat.article || '';
    this.name = mat.name || '';
    this.type = mat.type || MaterialType.Plate;
    this.textureName = mat.textureName || '';
    this.color = mat.color || '';
    this.panels = mat.panels || [];
    this.offcuts = mat.offcuts || [];
    this.measureName = mat.measureName || '';
    this.usedOffcuts = mat.usedOffcuts || [];
    this.groupId = mat.groupId || 0;
    this.weightPerItem = mat.weightPerItem || 0;
    this.textureRotationDegree = mat.textureRotationDegree || 0;
    this.textureLink = mat.textureLink || '';
    this.cropTextureLink = mat.cropTextureLink || '';
    this.quantityInStock = mat.quantityInStock || 0;
  }
}

export enum MaterialsCompareType {
  NameAndArticle,
  Name,
  Article,
  NameOrArticle,
}
